<div class="with-floating-button">
    <div class="content">
        <page-header [title]="'admin.frais.typesCharges.title' | translate"
                     [listeItems]="listeTabItems"
                     (onGoBack)="onGoBackTypesCharges()">
        </page-header>
        <mat-card *ngIf="typeCharge">
            <mat-card-title>
                <span [translate]="'admin.frais.typesCharges.infos.title'">
                </span>
            </mat-card-title>
            <mat-card-content>
                <form #form="ngForm" ngDefaultControl name="factures-types-charges-infos" autocomplete="off">
                    <div class="row">
                        <custom-input name="idTypeFile"
                                      id="idTypeFile"
                                      customType="select"
                                      libelle="admin.frais.typesCharges.infos.formatImport"
                                      [(ngModel)]="typeCharge.idTypeFile"
                                      optionValue="id"
                                      optionDisplay="libelle"
                                      [selectOptions]="typesChargesService.typesFiles"
                                      ngDefaultControl
                                      lCol="2"
                                      [required]="true"></custom-input>
                        <label class="col-md-2" [class.has-error]="!typeCharge.codeFamille">
                            <span [translate]="'admin.frais.typesCharges.infos.nature'"></span>
                            <span *ngIf="!typeCharge.codeFamille">*</span>
                        </label>
                        <div class="col-md-1 py-3 r-flex">
                            <i class="material-icons-outlined clickable" (click)="openIconeDialog()">{{ typeCharge.codeFamille ? NatureVoyage.getIcone(typeCharge.codeFamille) : 'search' }}</i>
                            <mat-icon class="material-icons mb-md-2 ms-2" [matTooltip]="'admin.frais.referentiels.infos.tips.icone' | translate">
                                info_outline
                            </mat-icon>
                            <input type="hidden" name="codeFamille" [(ngModel)]="typeCharge.codeFamille" required>
                        </div>

                    </div>
                    <div class="row">
                    <custom-input [(ngModel)]="typeCharge.libelle"
                                  id="libelle"
                                  name="libelle"
                                  customType="input"
                                  libelle="admin.frais.typesCharges.infos.libelle"
                                  [required]="true"
                                  lCol="2"
                                  ngDefaultControl>
                    </custom-input>
                    <custom-input [(ngModel)]="typeCharge.code"
                                  id="code"
                                  name="code"
                                  customType="input"
                                  libelle="admin.frais.typesCharges.infos.code"
                                  [required]="true"
                                  [readonly]="!isCreation"
                                  lCol="2"
                                  ngDefaultControl>
                    </custom-input>
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
        <router-outlet></router-outlet>
    </div>
    <!-- Utilisation du composant floating-button pour les actions -->
    <floating-button *ngIf="listeActions?.value" [listeActions]="listeActions"></floating-button>
</div>
<please-wait class="content" *ngIf="!typeCharge"></please-wait>
